// DESKTOP IMAGES
import brokerImage from "../images/broker_image.svg";
import allInOneHub from "../images/crypto_hub.svg";
import keyPointers from "../images/key_pointers.svg";
import loginCTA from "../images/login_cta.svg";
import signUpCTA from "../images/sign_up_cta.svg";

// MOBILE IMAGES
import mobileBrokerImage from "../images/mobile_broker_image.svg";
import mobileAllInOneHub from "../images/mobile_crypto_hub.svg";
import mobileKeyPointers from "../images/mobile_key_pointers.svg";

// UK IMAGES
import ukLanding from "../images/uk-landing.png";

export const CAROUSEL_IMAGES_LOGIN: string[] = [loginCTA, brokerImage, allInOneHub, keyPointers];
export const CAROUSEL_IMAGES_SIGNUP: string[] = [signUpCTA, brokerImage, allInOneHub, keyPointers];

export const CAROUSEL_IMAGES_MOBILE: string[] = [
  mobileBrokerImage,
  mobileAllInOneHub,
  mobileKeyPointers,
];

// UK visitors see the UK landing image in place of the all-in-one crypto hub slide
export function getCarouselImages(
  mode: "login" | "signup",
  isMobile: boolean,
  isUserFromUk: boolean,
): string[] {
  const images = isMobile
    ? CAROUSEL_IMAGES_MOBILE
    : mode === "login"
    ? CAROUSEL_IMAGES_LOGIN
    : CAROUSEL_IMAGES_SIGNUP;

  if (!isUserFromUk) return images;

  return images.map((image) =>
    image === allInOneHub || image === mobileAllInOneHub ? ukLanding : image,
  );
}

export const CAROUSEL_TEXT: string[] = [
  "",
  "Trusted since 2016",
  "Your all-in-one crypto hub",
  "Your personal crypto brokerage",
];

export const CAROUSEL_SUBHEADER_TEXT: string[] = [
  "",
  "Guiding crypto investors, one-on-one",
  "Intuitive interface built to work seamlessly with your crypto broker",
  "With decades of combined experience",
];
